import * as React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import {
  BLOCK_MIN_WIDTH, COMMON_PADDING,
  FIELD_MIN_WIDTH
} from './constants';

export default function ItemBox(props) {
  const {
    routes, children, ...other
  } = props;

  const minWidth = React.useMemo(() => {
    const mW = (BLOCK_MIN_WIDTH + COMMON_PADDING) * (routes?.length || 1);
    return Math.max(mW, FIELD_MIN_WIDTH);
  }, [routes?.length]);

  return (
    <Box
      sx={{
        minWidth: `${minWidth}px`,
        flexGrow: 1,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

ItemBox.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};

ItemBox.defaultProps = {
  routes: [],
};
